// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"CreateItem_text-gradient__2YIBu","container":"CreateItem_container__3hmU1"};